import { render, staticRenderFns } from "./PayloadViewer.vue?vue&type=template&id=18667626&scoped=true&"
import script from "./PayloadViewer.vue?vue&type=script&lang=js&"
export * from "./PayloadViewer.vue?vue&type=script&lang=js&"
import style0 from "./PayloadViewer.vue?vue&type=style&index=0&id=18667626&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18667626",
  null
  
)

export default component.exports